import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import Grid from '@material-ui/core/Grid';
// import SectionHeader from '../../components/SectionHeader';
import FormComponent from '../../components/FormComponent';
import { getGlobalClasses } from '../../themes';
import Note from '../../components/Note';
import { Paper } from '@material-ui/core';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		formDivider: {
			width: '100%',
			marginTop: 10,
			border: '1px dashed #ddd',
			marginBottom: 15,
		},
		activityContainer: {
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 5,
			[theme.breakpoints.up('sm')]: {
				borderLeft: 'none',
			},
		},
		activityUserRow: {
			marginTop: 10,
			marginBottom: 5,
		},
		activityUser: {
			whiteSpace: 'nowrap',
			fontWeight: 800,
			marginRight: 5,
		},
		activityText: {},
		activityTypeRow: {
			marginBottom: 15,
		},
		activityDate: {
			fontSize: '85%',
			color: '#666',
			paddingBottom: 2,
			[theme.breakpoints.up('sm')]: {
				paddingTop: 2,
			},
		},
		activityType: {
			display: 'inline-block',
			fontWeight: 500,
			fontSize: '85%',
			padding: '5px 10px',
			marginRight: 5,
			borderRadius: 2,
		},
		approved: {
			color: '#0288D1',
			backgroundColor: '#E1F5FE',
		},
		confirmed: {
			color: '#43A047',
			backgroundColor: '#E8F5E9',
		},
		denied: {
			color: '#D32F2F',
			backgroundColor: '#FFEBEE',
		},
		cancelled: {
			color: '#D32F2F',
			backgroundColor: '#FFEBEE',
		},
		opened: {
			color: '#AFB42B',
			backgroundColor: '#F9FBE7',
		},
	};
};

class RequestActivity extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			dateAndHours: [
				{
					date: '',
					hours: '',
				},
			],
		};
	}
	renderStatus = () => {
		const { ptoRequest, classes, userMap } = this.props;

		if (!ptoRequest) {
			return;
		}
		const {
			status,
			requestedForUserId,
			assignedToSupervisorUserId,
			assignedToHrUserId,
		} = ptoRequest;

		const requestor = userMap[requestedForUserId] || { firstName: 'Unknown requested.' };
		const supervisor = userMap[assignedToSupervisorUserId] || { firstName: 'Not assigned yet.' };
		const hr = userMap[assignedToHrUserId] || { firstName: 'Not assigned yet.' };

		return (
			<Grid item xs={12}>
				<Note type="info">
					<div className={classes.statusRow}>
						<strong>Requested for:</strong> {requestor.firstName} {requestor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to Supervisor:</strong> {supervisor.firstName} {supervisor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to HR:</strong> {hr.firstName} {hr.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Current Status:</strong> {_.startCase(status)}
					</div>
				</Note>
			</Grid>
		);
	};

	render() {
		const { classes, ptoRequest } = this.props;

		if (!ptoRequest) {
			return <div>Loading PTO request...</div>;
		}

		const { ptoRequestLogs } = ptoRequest;
		let logs = [];
		if (!_.isEmpty(ptoRequestLogs)) {
			logs = ptoRequestLogs;
		}

		logs = _.sortBy(logs, 'dateCreated');

		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>Activity</div>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={11} lg={10}>
						{!_.isEmpty(logs) &&
							logs.map((log) => {
								const {
									ptoRequestLogId,
									changeLog,
									// creatorUserId,
									dateCreated,
									logType,
									note,
								} = log;

								/*
								const user = userMap[creatorUserId] || {
									firstName: 'Missing',
									lastName: 'Missing',
								};
								*/

								const dateFormatted = moment(dateCreated).format('M/D h:mm a');
								return (
									<Grid
										container
										item
										md={12}
										className={classes.activityContainer}
										key={ptoRequestLogId}
									>
										<Grid item xs={12} sm={12}>
											<div className={classes.activityUserRow}>
												{/*
												<span className={classes.activityUser}>
													{user.firstName} {user.lastName}
												</span>
												*/}
												<span className={classes.activityText}>{changeLog}</span>
											</div>
											<div className={classes.activityTypeRow}>
												<span className={`${classes.activityType} ${classes[logType]}`}>
													{logType}
												</span>
												<span className={classes.activityDate}>{dateFormatted}</span>
												{note && (
													<div>
														<strong>Note:</strong>
														<pre style={{ margin: 0, padding: 5, fontSize: 18 }}>{note}</pre>
													</div>
												)}
											</div>
										</Grid>
									</Grid>
								);
							})}
					</Grid>
				</Grid>
			</Paper>
		);
	}
}

RequestActivity.propTypes = {
	ptoRequest: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer])(RequestActivity);
